import { PrimaryButton } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import {
  breakpoint,
  breakpointDown,
  styled,
  css,
} from '@moonpig/launchpad-utils'

export const StyledConciergeButton = styled(PrimaryButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-width: 1px;
  min-width: 128px;

  ${s({
    color: 'colorTextInverted',
    bgcolor: 'colorInteractionButton',
    borderColor: 'colorInteractionButton',
    borderRadius: 'borderRadius06',
    gap: 2,
    marginY: 0,
  })}

  ${css`
    ${breakpointDown('md')} {
      align-self: center;
      ${s({
        paddingTop: 0,
        paddingBottom: 0,
        px: 3,
        height: '40px',
        minHeight: '40px',
      })}
    }
  `}

  ${breakpoint('md')} {
    align-self: stretch;
    height: 100%;
    ${s({
      paddingTop: 0,
      paddingBottom: 0,
    })}
  }

  &:not(:disabled):hover {
    ${s({
      bgcolor: 'colorInteractionButtonHover',
      borderColor: 'colorInteractionButtonHover',
    })}
  }

  &:not(:disabled):focus {
    ${s({
      bgcolor: 'colorInteractionButtonFocus',
      borderColor: 'colorInteractionButtonFocus',
    })}
  }

  &:not(:disabled):active {
    transform: translateY(0);
  }
`
